import { twMerge } from 'tailwind-merge';

import { FirstBlock } from './FirstBlock';
import { SecondBlock } from './SecondBlock';
import { ThirdBlock } from './ThirdBlock';

type StatisticsSkeletonProps = {
  className?: string;
};

export default function StatisticsSkeleton(props: StatisticsSkeletonProps) {
  const { className } = props;

  return (
    <div className={twMerge('flex flex-col gap-[8px] animate-pulse', className)}>
      <FirstBlock />
      <SecondBlock />
      <ThirdBlock />
    </div>
  );
}
